
import React from 'react'
import { RadioGroup } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/solid'
import '../../view/css/steps.css'

function classNames(...classes) { return classes.filter(Boolean).join(' ') }

function RadioGroupGeneric({ value, setValue, array, error, defaultV, onBlur, image, title, numberCol, flex, sizeImg }) {
    return (
        <RadioGroup value={value} onChange={setValue} className='w-full group'>
            <RadioGroup.Label className=" grayscale    block text-sm font-medium text-[#09101f]">{title} </RadioGroup.Label>
            <div className={`mt-1 ${flex ? 'flex w-full flex-col lg:flex-row gap-[25px] justify-center ' : `grid lg:grid-cols-${numberCol} lg:grid-cols-${numberCol} gap-y-6 sm:grid-cols-2 sm:gap-x-4`}`}>
                {array.map((ban, index) => (
                    <RadioGroup.Option
                        key={index}
                        value={ban || ''}
                        defaultValue={defaultV}
                        onBlur={onBlur}
                        className={({ checked, active }) =>
                            classNames(
                                error ? 'border-red-500' : 'border-gray-300 ',
                                checked ? 'border-transparent' : 'border-gray-300 ',
                                active ? 'ring-2 ring-[#5ab9e5]' : '',
                                `relative bg-white border rounded-lg hover:border-[#5ab9e5] ${flex && 'lg:w-[30%] '}    transition-all duration-500 shadow-sm p-4 flex cursor-pointer focus:outline-none`
                            )
                        }
                    >
                        {({ checked, active }) => (
                            <>
                                <div className="flex-1 flex">
                                    <div className="flex h-full flex-col-reverse gap-4 w-full justify-center items-center ">
                                        <RadioGroup.Label as="span" className="block text-lg">
                                            <span className={`${checked ? 'text-black font-medium ' : 'text-[#a0a0a0] '}  transition-all  duration-100 `}>
                                                {ban.title}
                                            </span>

                                        </RadioGroup.Label>
                                        {
                                            image === 'yes' && (<>
                                                <RadioGroup.Description
                                                    as="span"
                                                    className="mt-1 flex items-center text-lg text-gray-500"
                                                >
                                                    <div className={` ${sizeImg ? 'w-full' : 'w-[80px]'} transition-all  duration-300 `}>
                                                        <img className='fill-orange-500 w-full object-contain h-[80px] ' src={ban?.logo} alt="" />
                                                    </div>
                                                </RadioGroup.Description>
                                            </>)
                                        }

                                    </div>
                                </div>
                                {checked ? (
                                    <CheckCircleIcon className="h-7 w-7 absolute right-0 top-0 pt-1 pr-1 text-[#5ab9e5]  " aria-hidden="true" />
                                ) : null}
                                <div
                                    className={classNames(
                                        active ? 'border' : 'border-2',
                                        checked ? 'border-[#5ab9e5] grayscale-0' : 'border-transparent',
                                        'absolute -inset-px rounded-lg pointer-events-none  transition-all  duration-300'
                                    )}
                                    aria-hidden="true"
                                />
                            </>
                        )}
                    </RadioGroup.Option>
                ))}
            </div>
        </RadioGroup>
    )
}

export default RadioGroupGeneric